var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5655 3.68461C6.5945 3.71286 6.7185 3.81953 6.8205 3.9189C7.462 4.50146 8.512 6.02119 8.8325 6.81661C8.884 6.93741 8.993 7.24282 9 7.40599C9 7.56235 8.964 7.7114 8.891 7.85363C8.789 8.03093 8.6285 8.17316 8.439 8.2511C8.3075 8.30127 7.914 8.3792 7.907 8.3792C7.4765 8.45714 6.777 8.5 6.004 8.5C5.2675 8.5 4.5965 8.45714 4.1595 8.39333C4.1525 8.38602 3.6635 8.30809 3.496 8.22285C3.19 8.06649 3 7.76108 3 7.43424L3 7.40599C3.0075 7.19313 3.1975 6.74549 3.2045 6.74549C3.5255 5.99294 4.524 4.50828 5.1875 3.91159C5.1875 3.91159 5.358 3.74355 5.4645 3.67048C5.6175 3.5565 5.807 3.5 5.9965 3.5C6.208 3.5 6.405 3.56381 6.5655 3.68461Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow__up.ff0c9d62f66d5794bd4bd252fcb21b54.svg";
export { ForwardRef as ReactComponent };